var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconionicMdAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 16.25 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-add",
    "data-name": "Icon ionic-md-add",
    d: "M23,15.958H15.958V23H13.792V15.958H6.75V13.792h7.042V6.75h2.167v7.042H23Z",
    transform: "translate(-6.75 -6.75)",
    fill: "#3d3d3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdAdd);
export default __webpack_public_path__ + "static/media/Icon ionic-md-add.f14327755956fba99b4f2e7a8e306272.svg";
export { ForwardRef as ReactComponent };